<div class="item-container">
    <div class="item-header">       
        <h5 class="text-center" >{{ "View" | translate }} {{"Folder"|translate}}</h5>
        <div class="edit-icons" (click)="onCancel()" mat-dialog-close>
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-contaier mt-4">
        <div class="emp-detail px-4" *ngIf="empCourseData!=''">
          <div class="d-flex justify-content-between flex-wrap align-items-center">

            <div class="back cursor-pointer mb-3 mb-lg-5 d-flex" (click)="onBack()" *ngIf="isBackAvailable">
              <i class="material-icons ps-2">keyboard_backspace</i>
              Back
            </div>
          </div>         
            <h6 class="mb-2" *ngIf="empCourseData.folder.length >0">Folders</h6>
            <div class="d-flex flex-wrap" *ngIf="empCourseData.folder.length >0">
              <div class="fol-cont " *ngFor="let item of empCourseData.folder">
                <div class="fol-b d-flex justify-content-between align-items-center" >
                  <div class="d-flex align-items-center " (click)="getEmpCourseWork(item.id,item.employee_id)">
                    <div>
                      <img src="assets/images/documents/folder.png" class="img-fluid">
                    </div>
                    <div class="ps-2">
                      <div class="f-h">{{item.title}}</div>
                    </div>
                  </div>
                  <i class="material-icons cursor-pointer" [matMenuTriggerFor]="menu2">more_vert</i>
                  <mat-menu #menu2="matMenu">
                    <button mat-menu-item color="warn"   (click)="onDeleteItem(item.id)" type="button">
                      <mat-icon class="kt-margin-r-0">delete</mat-icon>
                      <span>Delete</span>
                    </button>
                    
                  </mat-menu>
                </div>
              </div>
            </div>
            <h6 class="mb-2 mt-4" *ngIf="empCourseData.files.length >0">Files</h6>
            <div class="d-flex flex-wrap" *ngIf="empCourseData.files.length >0">
              <div class="file-b d-flex flex-column" *ngFor="let item of empCourseData.files">
                <div class="file-img flex-grow-1 mb-2"></div>
                <div class="f-detail d-flex justify-content-between px-2">
                  <div class="d-flex">
                    <div class="f-img">
                      <img src="assets/images/documents/pdf.png" class="img-fluid">
                    </div>
                    <div class="ps-2">
                      <div class="f-h">{{item.title}}</div>
                    </div>
                  </div>
                    <i class="material-icons cursor-pointer del-ic" [matMenuTriggerFor]="menu">more_vert</i>
                  <mat-menu #menu="matMenu" >
                    <button mat-menu-item color="warn"  (click)="onFileDownload(item.document)"
                    type="button" >
                    <mat-icon class="kt-margin-r-0">cloud_download</mat-icon>
                    <span>Download</span>
                </button>
                    <button mat-menu-item color="warn"  (click)="onDeleteItem(item.id)" type="button">
                      <mat-icon class="kt-margin-r-0">delete</mat-icon>
                      <span>Delete</span>
                    </button>
                    
                  </mat-menu>
                </div>
              </div>
            </div>
          </div>
          <div class="mat-table__message "  *ngIf="!isSpinnerLoading && isNoRecordFound">
            <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
          </div>       
    </div>
</div>
<!-- <app-loading-spinner></app-loading-spinner> -->